import * as React from "react";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import logo from "../images/logo_dell.png";
import { useParams, useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header2";
import {useEffect, useState } from "react";


const Content = () => {
    const { t } = useTranslation("common");
    const { type } = useParams();
    const navigate = useNavigate();
    
    useEffect(()=>{
        console.log(type);
        if(!(type == "success" || type == "error" || type == "errorRenewal" || type == "successRenewal")) {
            console.log("inside If");
            navigate("/notfound", { replace: true });
        }
    },[type, navigate]);

    let param:any = "success";
    if (type !== undefined) {
        param = type;
    }
    let days = localStorage.getItem("client") === "EDM" ? "90" : "45";
    let url:any = localStorage.getItem("loginUrl") ? localStorage.getItem("loginUrl") : "";
    return (
        <div className="row justify-content-center pt-5">
            <div className="h-67vh col-10">
                <div className={`pt-5 pb-25 custom-bg text-dark text-center`}>
                {param === "success" ? (<div><div> {t("Thanks_msg")}</div><br/><div>{t("email-sent")} {t("use_std_key")}<br/>{t("from_email")}<br/>{t("On_Prem_WSA")}<br/><br/><br/><br/><b>{t("note")}</b>{t("std_success_note")}<a href="https://www.dell.com/support/home/en-us/product-support/product/wyse-wms/drivers">{t("dellSupport")}</a><br/><br/></div></div>) : (param === "successRenewal" ? (<div> {t("Thanks_msg_renewal")} </div>) : (param === "errorRenewal" ? (<div>{ t("Renewal_error") }</div>) : (<div>{t("reg_error")}</div>))) }
                    <div className="mb-25 pt-2 pb-20">
                        {t("help_text")} <a target="_blank" rel="noopener noreferrer" href="https://www.dell.com/support/home/en-us/product-support/product/wyse-wms/overview">{days === "90" ? t("iot") : t("wyse_label")} {t("support")}</a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default function Confirmationmsg() {
    return (
        <div className="wrapper">
            <Header />
            <Content />
            <Footer />
        </div>
    );
}